<!-- Decorative Side Illustrations -->

<div class="container">
    <div class="page-header">
        <div class="breadcrumb">
            <span class="breadcrumb-item" (click)="goBack()">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="icon">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
                </svg>
                Drivers
            </span>
            <span class="breadcrumb-separator">></span>
            <span class="breadcrumb-item active">Add Driver</span>
        </div>
        <button class="btn-back" (click)="goBack()">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="icon">
                <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
            </svg>
            Go Back
        </button>
    </div>
    <div class="form-scroll-area">
        <!-- Profile Section -->
        <div class="form-section" style="padding: 20px 24px;">
            <div style="display: flex; align-items: center; gap: 24px;">
                <div class="profile-upload-section" style="gap: 8px; flex-direction: row; align-items: center;">
                    <div class="profile-photo-wrapper">
                        <div class="profile-photo" [class.has-photo]="profilePhotoPreview">
                            <img *ngIf="profilePhotoPreview" [src]="profilePhotoPreview"
                                style="width: 100%; height: 100%; object-fit: cover; border-radius: 50%;">
                            <svg *ngIf="!profilePhotoPreview" xmlns="http://www.w3.org/2000/svg" fill="none"
                                viewBox="0 0 24 24" stroke-width="1.5" stroke="white"
                                style="width: 56px; height: 56px;">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
                            </svg>
                        </div>
                        <button class="profile-edit-btn" (click)="photoInput.click()" type="button">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor" style="width: 18px; height: 18px;">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M6.827 6.175A2.31 2.31 0 015.186 7.23c-.38.054-.757.112-1.134.175C2.999 7.58 2.25 8.507 2.25 9.574V18a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9.574c0-1.067-.75-1.994-1.802-2.169a47.865 47.865 0 00-1.134-.175 2.31 2.31 0 01-1.64-1.055l-.822-1.316a2.192 2.192 0 00-1.736-1.039 48.774 48.774 0 00-5.232 0 2.192 2.192 0 00-1.736 1.039l-.821 1.316z" />
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M16.5 12.75a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM18.75 10.5h.008v.008h-.008V10.5z" />
                            </svg>
                        </button>
                        <input #photoInput type="file" style="display: none;" accept="image/*"
                            (change)="onProfilePhotoChange($event)">
                    </div>
                    <span class="upload-label" style="font-size: 11px;">Upload Photo</span>
                </div>

                <div style="flex: 1; max-width: 450px;">
                    <div class="driver-type-toggle">
                        <button class="toggle-option" [class.active]="driverForm.driverType === 'associated'"
                            (click)="toggleDriverType('associated')" type="button">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor" class="toggle-icon">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
                            </svg>
                            Associated Driver
                        </button>
                        <button class="toggle-option" [class.active]="driverForm.driverType === 'head'"
                            (click)="toggleDriverType('head')" type="button">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor" class="toggle-icon">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M16.5 18.75h-9m9 0a3 3 0 013 3h-15a3 3 0 013-3m9 0v-3.375c0-.621-.503-1.125-1.125-1.125h-.871M7.5 18.75v-3.375c0-.621.504-1.125 1.125-1.125h.872m5.007 0H9.497m5.007 0a7.454 7.454 0 01-.982-3.172M9.497 14.25a7.454 7.454 0 00.981-3.172M5.25 4.236c-.982.143-1.954.317-2.916.52A6.003 6.003 0 007.73 9.728M5.25 4.236V4.5c0 2.108.966 3.99 2.48 5.228M5.25 4.236V2.721C7.456 2.41 9.71 2.25 12 2.25c2.291 0 4.545.16 6.75.47v1.516M7.73 9.728a6.726 6.726 0 002.748 1.35m8.272-6.842V4.5c0 2.108-.966 3.99-2.48 5.228m2.48-5.492a46.32 46.32 0 012.916.52 6.003 6.003 0 01-5.395 4.972m0 0a6.726 6.726 0 01-2.749 1.35m0 0a6.772 6.772 0 01-3.044 0" />
                            </svg>
                            Head Driver
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Personal Information -->
        <div class="form-section">
            <div class="section-title">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="section-icon">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5zm6-10.125a1.875 1.875 0 11-3.75 0 1.875 1.875 0 013.75 0zm1.294 6.336a6.721 6.721 0 01-3.17.789 6.721 6.721 0 01-3.168-.789 3.376 3.376 0 016.338 0z" />
                </svg>
                Personal Information
            </div>

            <div class="form-row">
                <div class="form-group">
                    <label class="form-label">First Name<span class="required-star">*</span></label>
                    <input type="text" [(ngModel)]="driverForm.firstName" class="form-input"
                        [class.error]="errors['firstName']" placeholder="Enter first name"
                        (input)="capitalizeFirstLetter('firstName')">
                    <div class="error-message" *ngIf="errors['firstName']" [class.show]="errors['firstName']">
                        {{errors['firstName']}}
                    </div>
                </div>
                <div class="form-group">
                    <label class="form-label">Last Name<span class="required-star">*</span></label>
                    <input type="text" [(ngModel)]="driverForm.lastName" class="form-input"
                        [class.error]="errors['lastName']" placeholder="Enter last name"
                        (input)="capitalizeFirstLetter('lastName')">
                    <div class="error-message" *ngIf="errors['lastName']" [class.show]="errors['lastName']">
                        {{errors['lastName']}}
                    </div>
                </div>
            </div>

            <div style="display: grid; grid-template-columns: 100px 1fr 1fr; gap: 20px; margin-bottom: 16px;">
                <div class="form-group" style="margin-bottom: 0;">
                    <label class="form-label">Code</label>
                    <select [(ngModel)]="driverForm.countryCode" class="form-input" style="text-align: center;">
                        <option *ngFor="let country of countryCodes" [value]="country.dial_code">
                            {{ country.code }} {{ country.dial_code }}
                        </option>
                    </select>
                </div>
                <div class="form-group" style="margin-bottom: 0;">
                    <label class="form-label">Phone Number<span class="required-star">*</span></label>
                    <input type="tel" [(ngModel)]="driverForm.phone" class="form-input" [class.error]="errors['phone']"
                        placeholder="1234567890" maxlength="10" (input)="onPhoneInput($event)">
                    <div class="error-message" *ngIf="errors['phone']" [class.show]="errors['phone']">
                        {{errors['phone']}}
                    </div>
                </div>
                <div class="form-group" style="margin-bottom: 0;">
                    <label class="form-label">Confirm Phone Number<span class="required-star">*</span></label>
                    <input type="tel" [(ngModel)]="driverForm.confirmPhone" class="form-input"
                        [class.error]="errors['confirmPhone']" placeholder="1234567890" maxlength="10"
                        (input)="onPhoneInput($event)">
                    <div class="error-message" *ngIf="errors['confirmPhone']" [class.show]="errors['confirmPhone']">
                        {{errors['confirmPhone']}}
                    </div>
                </div>
            </div>

            <div class="form-group">
                <label class="form-label">Address<span class="required-star">*</span></label>
                <input type="text" [(ngModel)]="driverForm.address" class="form-input" [class.error]="errors['address']"
                    placeholder="Enter full address">
                <div class="error-message" *ngIf="errors['address']" [class.show]="errors['address']">
                    {{errors['address']}}
                </div>
            </div>

            <div class="form-row">
                <div class="form-group">
                    <label class="form-label">Email Address<span class="required-star">*</span></label>
                    <input type="email" [(ngModel)]="driverForm.email" class="form-input"
                        [class.error]="errors['email']" placeholder="driver@example.com"
                        autocomplete="off">
                    <div class="error-message" *ngIf="errors['email']" [class.show]="errors['email']">
                        {{errors['email']}}
                    </div>
                </div>
                <div class="form-group"*ngIf="this.isAddMode">
                    <label class="form-label">Password<span class="required-star">*</span></label>
                    <input type="password" [(ngModel)]="driverForm.password" class="form-input"
                        [class.error]="errors['password']" placeholder="Enter password"
                        autocomplete="new-password">
                    <div class="error-message" *ngIf="errors['password']" [class.show]="errors['password']">
                        {{errors['password']}}
                    </div>
                </div>
            </div>
        </div>

        <!-- Documents Section -->
        <div class="form-section">
            <div class="section-title">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="section-icon">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
                </svg>
                Documents Upload
            </div>

            <div class="document-grid">
                <div *ngFor="let docType of documentTypes" class="document-card"
                    [class.uploaded]="documentPreviews[docType.id]" (click)="documentInput.click()">

                    <!-- Preview for uploaded documents -->
                    <div *ngIf="documentPreviews[docType.id]" class="doc-preview">
                        <!-- Image preview -->
                        <div *ngIf="documentPreviews[docType.id].type === 'image'" class="doc-preview-wrapper">
                            <img [src]="documentPreviews[docType.id].preview" class="doc-preview-image">
                            <div class="doc-preview-overlay">
                                <div class="doc-filename">{{documentPreviews[docType.id].name}}</div>
                            </div>
                        </div>

                        <!-- PDF preview -->
                        <div *ngIf="documentPreviews[docType.id].type === 'pdf'" class="doc-preview-wrapper">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                style="width: 56px; height: 56px; color: #ef4444;">
                                <path fill-rule="evenodd"
                                    d="M5.625 1.5c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0016.5 9h-1.875a1.875 1.875 0 01-1.875-1.875V5.25A3.75 3.75 0 009 1.5H5.625zM7.5 15a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5A.75.75 0 017.5 15zm.75 2.25a.75.75 0 000 1.5H12a.75.75 0 000-1.5H8.25z" />
                                <path
                                    d="M12.971 1.816A5.23 5.23 0 0114.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 013.434 1.279 9.768 9.768 0 00-6.963-6.963z" />
                            </svg>
                            <span class="pdf-badge">PDF</span>
                            <div class="doc-filename">{{documentPreviews[docType.id].name}}</div>
                        </div>

                        <!-- Other file types -->
                        <div *ngIf="documentPreviews[docType.id].type === 'other'" class="doc-preview-wrapper">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor" style="width: 48px; height: 48px; color: #10b981;">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            <div class="doc-filename">{{documentPreviews[docType.id].name}}</div>
                        </div>

                        <button class="doc-remove" (click)="removeDocument(docType.id); $event.stopPropagation()">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                                stroke="currentColor" style="width: 14px; height: 14px;">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>

                    <!-- Default state -->
                    <ng-container *ngIf="!documentPreviews[docType.id]">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1"
                            stroke="currentColor" class="doc-icon">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
                        </svg>
                        <span class="doc-label">{{docType.label}}</span>
                    </ng-container>

                    <input #documentInput type="file" [id]="docType.id + 'Input'" style="display: none;"
                        accept=".pdf,.jpg,.jpeg,.png" (change)="onDocumentChange($event, docType.id)">
                </div>

                <!-- Add More -->
                <div class="document-card" (click)="addMoreDocument()">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1"
                        stroke="currentColor" class="doc-icon">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <span class="doc-label">Add More</span>
                </div>
            </div>
        </div>
    </div>

    <!-- Action Buttons -->
    <div class="form-actions">
        <button class="btn btn-cancel" (click)="cancel()" type="button">Cancel</button>
        <button *ngIf="this.isAddMode" class="btn btn-submit" (click)="submitDriver()" type="button" [disabled]="loading">
            <ng-container *ngIf="!loading">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" style="width: 18px; height: 18px;">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                </svg>
                Add Driver
            </ng-container>
            <ng-container *ngIf="loading">
                <div class="btn-spinner"></div>
                Processing...
            </ng-container>
        </button>
          <button *ngIf="!this.isAddMode"  class="btn btn-submit" (click)="submitDriver()" type="button" [disabled]="loading">
            <ng-container *ngIf="!loading">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" style="width: 18px; height: 18px;">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                </svg>
                Update Driver
            </ng-container>
            <ng-container *ngIf="loading">
                <div class="btn-spinner"></div>
                Updating...
            </ng-container>
        </button>
    </div>
</div>